import { createBrowserHistory } from "history";

const history = createBrowserHistory();
// history.listen(location => {
//   history.push("mobile/test");
// })

export default history
